module.exports = __webpack_public_path__ + "static/media/icon-lead.64f18532.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon-lead.svg
// module id = 391
// module chunks = 0